import { render } from "./PhotoGalleryPage.vue?vue&type=template&id=52000d07&scoped=true"
import script from "./PhotoGalleryPage.vue?vue&type=script&scoped=true&lang=js"
export * from "./PhotoGalleryPage.vue?vue&type=script&scoped=true&lang=js"

import "./PhotoGalleryPage.vue?vue&type=style&index=0&id=52000d07&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ipc-app/ipc-app/apps/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52000d07"]])

export default __exports__